<template>
  <div>
    <section class="section mx-auto" style="padding-top:1em;max-width:1024px">
      <v-container>
      <div v-if="currentOffer">
        <div v-if="isDone" class="text-center">
          <h1>Synthèse de votre projet</h1>
          <br/>
          <div >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-right">
                      Question
                    </th>
                    <th class="text-left">
                      Votre réponse
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(step, idx) in currentOffer.project.steps" 
                    :key="step.id" 
                    @click="goToStep(idx)"
                  >
                    <td class="text-right"><i>{{ step.question }}</i></td>
                    <td class="text-left">{{ findAnswerLabel(step) }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </div>
        <div v-else>
          <QTitle 
            :cursor="cursor" 
            :nbQuestions="currentOffer.project.steps.length"
            :one="current"/>
          <component 
            v-if="current"
            :is="current.__component" 
            :cursor="cursor" 
            :nbQuestions="currentOffer.project.steps.length"
            :one="current"
            :offerIso="currentOffer.iso"
            @save="onSave"
            @update="onUpdate"
          />
        </div>
        <div class="d-flex justify-space-between mt-6">
          <v-btn @click="goPrev" :disabled="cursor <= 0">
            Précédent
          </v-btn>
          <v-btn @click="goNext" :disabled="!canGoNext({iso: currentOffer.iso, question: current.iso})" v-if="!isDone" color="#ef6758" style="color:white">
            Suivant
          </v-btn>
          <v-btn @click="goShop" v-if="isDone" color="#ef6758" style="color:white">
            Valider
          </v-btn>
        </div>
      </div>
      <div v-else>
        Chargement du questionnaire ...
      </div>
      </v-container>
    </section>
  </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'
import QTitle from '../components/project/QTitle.vue'
import QPicture from '../components/project/QPictureGeneric.vue'
import QPictureListing from '../components/project/QPictureListingGeneric.vue'
import QText from '../components/project/QTextGeneric.vue'
import QFree from '../components/project/QFreeGeneric.vue'

export default {
  components: { QTitle, QPicture, QText, QFree, QPictureListing },
  data: () => ({
    cursor: 0,
    isDone: false
  }),
  computed: {
    ...mapGetters('strapiv2', ['currentOffer']),
    ...mapGetters('project', ['canGoNext', 'getResponse']),
    current: function () {
      return this.currentOffer?.project.steps[this.cursor]
    }
  },
  methods: {
    ...mapActions('project', ['setResponse']),
    ...mapActions('strapiv2', ['setCurrentOffer']),
    goPrev () {
      window.scrollTo(0, 0)
      if (this.isDone) {
        this.isDone = false
      } else if (this.cursor > 0) {
        this.cursor--
      }
    },
    goShop () {
      this.$router.push(`/shop/${this.currentOffer.code}`)
    },
    goNext () {
      window.scrollTo(0, 0)
      if ((this.cursor + 1) === this.currentOffer?.project.steps.length) {
        this.isDone = true
      } else {
        this.cursor++
      }
    },
    goToStep (idx) {
      this.isDone = false
      this.cursor = idx
    },
    onSave (args) {
      this.onUpdate(args)
      this.goNext()
    },
    onUpdate (args) {
      this.setResponse({iso: this.currentOffer.iso, question: args.iso, response: args.response})
    },
    findAnswerLabel (step) {
      const ans = this.getResponse({iso: this.currentOffer.iso, question: step.iso})
      if (!step.answers) {
        return ans
      }

      for (let i = 0; i < step.answers.length; i++) {
        if (step.answers[i].iso === ans) {
          return step.answers[i].label
        }
      }

      return ans
    }
  },
  mounted () {
    const iso = this.$route.params.iso
    this.setCurrentOffer(iso)
  }
}
</script>